import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color", "responsive", "children"];
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import styledWithTheme from 'foundations-theming/utils';
import styled, { css } from 'styled-components';
import { GRID_BREAKPOINT_EXTRA_LARGE, GRID_BREAKPOINT_MEDIUM } from '../constants/';
import { jsx as _jsx } from "react/jsx-runtime";
const getBackgroundColor = (color = 'default') => {
  switch (color) {
    case 'light':
      return 'fill-surface-recessed';
    case 'dark':
      return 'fill-accent-neutral-default';
    case 'default':
    default:
      return 'fill-surface-default';
  }
};
const responsiveStylesMixin = props => {
  if (!props.responsive) {
    return '';
  }
  return css(["@media (max-width:", "){padding-block:", ";padding-inline:", ";}@media (max-width:", "){padding-block:", ";padding-inline:", ";}"], GRID_BREAKPOINT_EXTRA_LARGE, ({
    theme
  }) => theme.space['800'], ({
    theme
  }) => theme.space['900'], GRID_BREAKPOINT_MEDIUM, ({
    theme
  }) => theme.space['500'], ({
    theme
  }) => theme.space['600']);
};
const MainSectionContainer = styledWithTheme.div(({
  $spaceCssStyles,
  $color,
  theme
}) => {
  return Object.assign({
    backgroundColor: theme.color[$color],
    paddingBlock: theme.space['1000'],
    paddingInline: theme.space['1100']
  }, $spaceCssStyles);
});
const MainSection = styled(_ref => {
  let {
      color,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterProps(rest);
  const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx(MainSectionContainer, Object.assign({
      $color: getBackgroundColor(color),
      $spaceCssStyles: spaceCssStyles
    }, rest, {
      children: children
    }))
  );
}).withConfig({
  displayName: "MainSection"
})(["", ""], responsiveStylesMixin);
export default MainSection;